export const ORG_ROLES = [
  'owner',
  'admin',
  'manager',
  'designer',
  'motion_designer',
  'freelancer',
  'client_admin',
  'client_member',
] as const;

export type OrgRole = (typeof ORG_ROLES)[number];

export const INTERNAL_ROLES = ['owner', 'admin', 'manager', 'designer', 'motion_designer'] as const;
export const CLIENT_ROLES = ['client_admin', 'client_member'] as const satisfies readonly OrgRole[];

/** Papéis que podem ser atribuídos por convite na Fase 1 (papéis de cliente exigem um cliente: Fase 2). */
export const INVITABLE_ROLES = ['admin', 'manager', 'designer', 'motion_designer', 'freelancer'] as const;
export type InvitableRole = (typeof INVITABLE_ROLES)[number];

export const ROLE_LABELS: Record<OrgRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  designer: 'Designer',
  motion_designer: 'Motion Designer',
  freelancer: 'Freelancer',
  client_admin: 'Cliente (admin)',
  client_member: 'Cliente (membro)',
};

export function isClientRole(role: OrgRole): boolean {
  return (CLIENT_ROLES as readonly OrgRole[]).includes(role);
}
